<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-position="top"
    :show-message="false"
    :hide-required-asterisk="true"
  >
    <el-form-item label="temp" prop="title">
      <template slot="label">
        <label>{{t_content('botApp.tab03.title')}}</label>
        <el-tooltip placement="top" effect="light">
          <div slot="content">
            <span v-html="t_content('botApp.tab03.title.tooltip')"></span>
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
        <span class="hint" v-html="t_content('botApp.tab03.title.hint')"></span>
      </template>
      <el-input v-model="form.title"></el-input>
    </el-form-item>
    <el-form-item label="temp" prop="slogan">
      <template slot="label">
        <label>{{t_content('botApp.tab03.slogan')}}</label>
        <span class="hint">{{t_content('botApp.tab03.slogan.hint')}}</span>
      </template>
      <el-input v-model="form.slogan"></el-input>
    </el-form-item>
    <el-form-item label="temp" prop="desc">
      <template slot="label">
        <label>{{t_content('botApp.tab03.desc')}}</label>
        <span class="hint">{{t_content('botApp.tab03.desc.hint')}}</span>
      </template>
      <el-input type="textarea" v-model="form.desc"></el-input>
    </el-form-item>
    <el-form-item label="temp" prop="keyword">
      <template slot="label">
        <label>{{t_content('botApp.tab03.keyword')}}</label>
        <span class="hint">{{t_content('botApp.tab03.keyword.hint')}}</span>
      </template>
      <tags-input
        element-id="tags"
        v-model="form.keyword"
        :typeahead="true"
        :class="kwinvalid"
        :limit="20"
      ></tags-input>
      <!--class="cust-invalid"-->
      <el-checkbox-group v-model="form.keyword" style="display:none"></el-checkbox-group>
    </el-form-item>
    <el-form-item :label="t_content('botApp.tab03.icons')" prop="icons">
      <el-upload
        :action="fileUploadApiUrl"
        list-type="picture-card"
        :before-remove="icons_handleRemove"
        :file-list="icons"
        accept="image/jpeg, image/gif, image/png, image/bmp"
:before-upload="(res)=>{return beforeAvatarUpload(res,{widths:[110,160,200,220],size:1,type:'square'})}"
        :on-success="icons_uploadSuccess"
        :on-error="handleError"
        :headers="headers"
        name="uploadFile"
      >
        <el-checkbox-group v-model="icons" style="display:none"></el-checkbox-group>
        <i class="el-icon-plus"></i>
      </el-upload>
      <p class="uploadtext">仅支持110,160,200,220正方形像素，jpg或png格式，大小不超过1MB</p>
    </el-form-item>
    <el-form-item label="temp" prop="screenshot">
      <template slot="label">
        <label>{{t_content('botApp.tab03.screenshot')}}</label>
        <span class="hint">{{t_content('botApp.tab03.screenshot.hint')}}</span>
      </template>
      <el-upload
        :action="fileUploadApiUrl"
        list-type="picture-card"
        :before-remove="screenshot_handleRemove"
        :file-list="screenshot"
        accept="image/jpeg, image/gif, image/png, image/bmp"
:before-upload="(res)=>{return beforeAvatarUpload(res,{width:580,height:340,size:2,type:'rotate'})}"
        :on-success="screenshot_uploadSuccess"
        :headers="headers"
        name="uploadFile"
        :limit="5"
      >
        <i class="el-icon-plus"></i>
        <el-checkbox-group v-model="screenshot" style="display:none"></el-checkbox-group>
      </el-upload>
      <p class="uploadtext">仅支持580*340像素，jpg或png格式，大小不超过2MB</p>
    </el-form-item>
  </el-form>
</template>

<script>
import _ from 'lodash'
import conf from '../../../../config'
import VoerroTagsInput from '@voerro/vue-tagsinput'
import { apiFileConfig } from '../../../../api/apiConfig'

export default {
    data () {
        var required = (rule, value, callback, label) => {
            let vm = this
            if (value) {
                if (value.length === 0) {
                    const errMsg =
                        label + ' ' + this.t_content('botApp.common.valid.required')
                    vm.$store.state.botAppErrMessages.push(errMsg)
                    callback(new Error('Please input the data'))
                } else {
                    callback()
                }
            } else {
                callback(new Error('Please input the data'))
            }
        }
        var required35 = (rule, value, callback, label) => {
            let vm = this
            let errMsg = ''

            if (value) {
                if (value.length === 0) {
                    errMsg =
                        label + ' ' + this.t_content('botApp.common.valid.required')
                    vm.$store.state.botAppErrMessages.push(errMsg)
                    callback(new Error(errMsg))
                } else if (value.length < 3 || value.length > 5) {
                    errMsg = 'Please upload 3 ~ 5 icons'
                    vm.$store.state.botAppErrMessages.push(errMsg)
                    callback(new Error(errMsg))
                } else {
                    callback()
                }
            } else {
                callback(new Error('Please input the data'))
            }
        }
        var requiredKW = (rule, value, callback, label) => {
            let vm = this
            if (value) {
                if (value.length === 0) {
                    const errMsg =
                        label + ' ' + this.t_content('botApp.common.valid.required')
                    vm.$store.state.botAppErrMessages.push(errMsg)
                    this.kwinvalid = 'cust-invalid'
                    callback(new Error('Please input the data'))
                } else {
                    this.kwinvalid = 'cust-valid'
                    callback()
                }
            } else {
                callback(new Error('Please input the data'))
            }
        }

        // let form = {
        //     langCode: '',
        //     tag: '',
        //     slogan: '',
        //     title: '',
        //     desc: '',
        //     videoUrl: '',
        //     icons: [],
        //     screenshot: [],
        //     // promotion: [],
        //     keyword: [],
        //     function: []
        // }

        // Object.assign(form, this.market)
        // let form = { ...this.cands }
        return {
            fileUploadApiUrl: apiFileConfig(),
            rules: {
                title: [{ required: true, trigger: 'blur' }],
                slogan: [{ required: true, trigger: 'blur' }],
                desc: [{ required: true, trigger: 'blur' }],
                keyword: [
                    {
                        validator: (rule, value, callback) =>
                            requiredKW(
                                rule,
                                value,
                                callback,
                                this.t_content('botApp.tab03.keyword')
                            ),
                        trigger: 'blur'
                    }
                ],
                icons: [
                    {
                        validator: (rule, value, callback) =>
                            required(
                                rule,
                                value,
                                callback,
                                this.t_content('botApp.tab03.icons')
                            ),
                        trigger: 'blur'
                    }
                ], // 220/200/160/110
                screenshot: [
                    {
                        validator: (rule, value, callback) =>
                            required35(
                                rule,
                                value,
                                callback,
                                this.t_content('botApp.tab03.screenshot')
                            ),
                        trigger: 'blur'
                    }
                ] // 580x340
            },
            kwinvalid: ''
        }
    },

    methods: {
        t_content (tKey) {
            return this.$t(tKey, {
                contentType: this.$t(`botApp.${this.$store.state.contentType}`)
            })
        },
        getDataFromChild () {
            return this.form
        },
        beforeAvatarUpload (file, json) {
            const isJPG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < json.size

            if (!isJPG && !isPNG) {
                this.$message.error('上传图片必须是JPG/PNG/格式!')
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 ' + json.size + 'M!')
            }

            // return (isJPG || isPNG) && isLt2M;

            let that = this
            let canWidth = true
            let canHeight = true
            return new Promise(function (resolve, reject) {
                var reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = function (event) {
                    var image = new Image()
                    image.src = event.target.result
                    image.onload = function () {
                        var width = this.width
                        var height = this.height

                        if (json.type === 'max') {
                            if (
                                width < json.width ||
                                height < json.width ||
                                width > json.height ||
                                height > json.height
                            ) {
                                canWidth = false
                            }
                        } else if (json.type === 'square') {
                            canWidth = _.reduce(
                                json.widths,
                                function (result, value, key) {
                                    return (
                                        result ||
                                        (width === value && height === value)
                                    )
                                },
                                false
                            )
                        } else if (json.type === 'rotate') {
                            let landscape =
                                width === json.width && height === json.height
                            let portrait =
                                height === json.width && width === json.height
                            canHeight = landscape || portrait
                        } else {
                            // 'same'
                            canWidth = width === json.width
                            canHeight = height === json.height
                        }

                        if (!canWidth || !canHeight) {
                            // eslint-disable-next-line prefer-promise-reject-errors
                            reject()
                            that.$message.error('请按照推荐尺寸上传')
                        }
                        resolve()
                    }
                }
            })
        },
        icons_uploadSuccess (response, file, fileList) {
            if (!this.form.icons) {
                this.form.icons = []
            }
            this.form.icons.push(response.url)
        },
        handleError (error) {
            alert(error)
        },
        screenshot_uploadSuccess (response, file, fileList) {
            if (!this.form.screenshot) {
                this.form.screenshot = []
            }
            this.form.screenshot.push(response.url)
        },
        icons_handleRemove (file, fileList) {
            if (file && file.status === 'success') {
                this.$confirm(
                    this.t_content('botApp.common.delete.dialog.msg'),
                    this.t_content('botApp.common.delete.dialog.title'),
                    {
                        confirmButtonText: this.t_content('botApp.common.delete.dialog.ok'),
                        cancelButtonText: this.t_content('botApp.common.delete.dialog.cancel'),
                        type: 'warning'
                    }
                ).then(() => {
                    var newList = fileList.filter(function (v) {
                        return v.url !== file.url
                    })
                    this.icons = newList
                })
                return false // 这是重点,不管上面的操作结果如何都返回false
            }
        },
        screenshot_handleRemove (file, fileList) {
            if (file && file.status === 'success') {
                this.$confirm(
                    this.t_content('botApp.common.delete.dialog.msg'),
                    this.t_content('botApp.common.delete.dialog.title'),
                    {
                        confirmButtonText: this.t_content('botApp.common.delete.dialog.ok'),
                        cancelButtonText: this.t_content('botApp.common.delete.dialog.cancel'),
                        type: 'warning'
                    }
                )
                    .then(() => {
                        var newList = fileList.filter(function (v) {
                            return v.url !== file.url
                        })
                        this.screenshot = newList
                    })
                    .catch(() => {})
                return false // 这是重点,不管上面的操作结果如何都返回false
            }
        }
    },
    components: {
        'tags-input': VoerroTagsInput
    },
    props: ['form'],
    computed: {
        isScreenshotMax () {
            return this.form.screenshot.length >= 5
        },
        icons: {
            get: function () {
                return _.map(this.form.icons, o => {
                    return { name: '', url: o }
                })
            },
            set: function (newValue) {
                this.form.icons = _.map(newValue, o => {
                    return o.url
                })
            }
        },
        screenshot: {
            get: function () {
                return _.map(this.form.screenshot, o => {
                    return { name: '', url: o }
                })
            },
            set: function (newValue) {
                this.form.screenshot = _.map(newValue, o => {
                    return o.url
                })
            }
        },
        headers () {
            return {
                Authorization: 'Basic ' + conf.fpsAuth
            }
        }
    }
}
</script>

<style>
@import './vue-tagsinput.css';

.cust-invalid > div {
    border-color: #f56c6c;
}
.cust-valid > div {
    border-color: #67c23a;
}
</style>
